// src/components/ForgotPassword.js
import React, { useState } from 'react';
import { sendPasswordResetEmail } from "firebase/auth";
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebaseConfig';
import '../styles/LoginSignup.css'; // Assumindo que você tenha um CSS compartilhado


const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('Email de redefinição de senha enviado! Verifique sua caixa de entrada.');
    } catch (error) {
      setError('Erro ao enviar email de redefinição: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <h2>Recuperar Senha</h2>
      <form onSubmit={handleResetPassword}>
        <div className="input-group">
          <input
            required
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input"
            autoComplete="off"
          />
          <label className="user-label">E-mail *</label>
        </div>
        <button
          type="submit"
          className="submit-button"
          disabled={loading}
        >
          {loading ? 'Enviando...' : 'Enviar email de recuperação'}
        </button>
        {message && <p className="message">{message}</p>}
        {error && <p className="error">{error}</p>}
      </form>
      <p className="signup-prompt">
      Lembrou sua senha? <a onClick={() => navigate('/')}>Acesse sua conta</a>
      </p>
    </div>
  );
};

export default ForgotPassword;
